/* Culture Supply · Favoritos (tabs) · cs-favoritos.js */
(function(){
  var toast;
  function showToast(title){
    if(!toast){
      toast=document.createElement('div');toast.id='csf-toast';
      toast.style.cssText='position:fixed;z-index:9999;left:50%;bottom:26px;transform:translateX(-50%) translateY(20px);background:#141414;color:#fff;padding:13px 18px;border-radius:12px;font:600 14px/1.3 Inter,sans-serif;box-shadow:0 10px 40px rgba(0,0,0,.3);display:flex;align-items:center;gap:14px;opacity:0;transition:all .28s ease;max-width:90vw';
      document.body.appendChild(toast);
    }
    toast.innerHTML='<span>&#10003; '+title+' adicionado</span><a href="/cart" style="color:#fff;text-decoration:underline;white-space:nowrap">Ver carrinho</a>';
    requestAnimationFrame(function(){toast.style.opacity='1';toast.style.transform='translateX(-50%) translateY(0)';});
    clearTimeout(toast._t);
    toast._t=setTimeout(function(){toast.style.opacity='0';toast.style.transform='translateX(-50%) translateY(20px)';},3200);
  }

  function init(root){
    if(root.dataset.csfReady)return; root.dataset.csfReady='1';
    var tabs=root.querySelectorAll('[data-csf-tab]');
    var panels=root.querySelectorAll('[data-csf-panel]');
    function activePanel(){return root.querySelector('.csf__panel.is-active');}

    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        var id=tab.getAttribute('data-csf-tab');
        tabs.forEach(function(t){var on=t===tab;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');});
        panels.forEach(function(p){
          var on=p.getAttribute('data-csf-panel')===id;
          p.classList.toggle('is-active',on);
          if(on){p.removeAttribute('hidden');p.querySelector('.csf__track').scrollLeft=0;}
          else{p.setAttribute('hidden','');}
        });
        updateArrows();
      });
    });

    var prev=root.querySelector('[data-csf-prev]');
    var next=root.querySelector('[data-csf-next]');
    function step(){var p=activePanel();if(!p)return 280;var c=p.querySelector('.csf-card');return c?c.getBoundingClientRect().width+16:280;}
    function updateArrows(){var p=activePanel();if(!p||!prev||!next)return;var t=p.querySelector('.csf__track');var max=t.scrollWidth-t.clientWidth-2;prev.disabled=t.scrollLeft<=2;next.disabled=t.scrollLeft>=max;}
    if(prev)prev.addEventListener('click',function(){var t=activePanel().querySelector('.csf__track');t.scrollBy({left:-step()*1.5,behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){var t=activePanel().querySelector('.csf__track');t.scrollBy({left:step()*1.5,behavior:'smooth'});});
    panels.forEach(function(p){p.querySelector('.csf__track').addEventListener('scroll',function(){if(p.classList.contains('is-active'))updateArrows();});});
    window.addEventListener('resize',updateArrows);
    updateArrows();

    root.querySelectorAll('[data-csf-add]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        if(btn.getAttribute('data-single')!=='true'){window.location.href=btn.getAttribute('data-url');return;}
        var id=btn.getAttribute('data-variant');
        if(!id){window.location.href=btn.getAttribute('data-url');return;}
        btn.classList.add('is-loading');
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
          .then(function(){
            showToast(btn.getAttribute('data-title')||'Produto');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
              document.querySelectorAll('[data-cart-count],.cart-count,.js-cart-count').forEach(function(el){el.textContent=c.item_count;});
            }).catch(function(){});
          })
          .catch(function(){window.location.href=btn.getAttribute('data-url');})
          .finally(function(){btn.classList.remove('is-loading');});
      });
    });
  }

  function boot(){document.querySelectorAll('.csf').forEach(init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
